// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* make sure to keep these in sync with other constants,
e.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */

/* layout contants from \`layout-constants.js\` */

/* overridden by src/lib/themes/guiHelpers.js */

/*
    Contains constants for the z-index values of elements that are part of the global stack context.
    In other words, z-index values that are "inside" a component are not added here.
    This prevents conflicts between identical z-index values in different components.
*/

/* Toolbox z-index: 40; set in scratch-blocks */

/* tooltips should go over add buttons if they overlap */

/* monitors go over add buttons */

/* "ask" block text input goes above monitors */

/* behind menu-bar */

/* Block drag z-index: 1000; default 50 is overriden in blocks.css */

/* so it is draggable into other panes */

/* behind modals */

/* behind modals */

/* in most interfaces, the context menu is always on top */

.blocks_blocks_xkzYb {
    height: 100%;
}

.blocks_drag-over_giZQU:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0.75;
    background-color: var(--drop-highlight);
    transition: all 0.25s ease;
}

.blocks_blocks_xkzYb .injectionDiv{
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    border: 1px solid var(--ui-black-transparent);
    border-top-width: 0px;
    border-bottom-width: 0px;
}

[dir="rtl"] .blocks_blocks_xkzYb .injectionDiv {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
}

.blocks_blocks_xkzYb .blocklyMainBackground {
    stroke: none;
}

.blocks_blocks_xkzYb .blocklyToolboxDiv {
    border-right: 1px solid var(--ui-black-transparent);
    border-bottom: 1px solid var(--ui-black-transparent);
    box-sizing: content-box;
    height: calc(100% - 3.25rem) !important;

    /*
        For now, the layout cannot support scrollbars in the category menu.
        The line below works for Edge, the \`::-webkit-scrollbar\` line
        below that is for webkit browsers. It isn't possible to do the
        same for Firefox, so a different solution may be needed for them.
    */
    -ms-overflow-style: none;
}

[dir="rtl"] .blocks_blocks_xkzYb .blocklyToolboxDiv {
    border-right: none;
    border-left: 1px solid var(--ui-black-transparent);
}

.blocks_blocks_xkzYb .blocklyToolboxDiv::-webkit-scrollbar {
    display: none;
}

.blocks_blocks_xkzYb .blocklyFlyout {
    border-right: 1px solid var(--ui-black-transparent);
    box-sizing: content-box;
}

[dir="rtl"] .blocks_blocks_xkzYb .blocklyFlyout {
    border-right: none;
    border-left: 1px solid var(--ui-black-transparent);
}

.blocks_blocks_xkzYb .blocklyBlockDragSurface {
    /*
        Fix an issue where the drag surface was preventing hover events for sharing blocks.
        This does not prevent user interaction on the blocks themselves.
    */
    pointer-events: none;
    z-index: 1000; /* make blocks match gui drag layer */
}

/*
    Shrink category font to fit "My Blocks" for now.
    Probably will need different solutions for language support later, so
    make the change here instead of in scratch-blocks.
*/

.blocks_blocks_xkzYb .scratchCategoryMenuItemLabel {
    font-size: 0.65rem;
}

.blocks_blocks_xkzYb .blocklyMinimalBody {
    min-width: auto;
    min-height: auto;
}
`, "",{"version":3,"sources":["webpack://./src/components/blocks/blocks.css"],"names":[],"mappings":"AAAA;sDACsD;;AAEtD,+CAA+C;;AAE/C,+CAA+C;;AAE/C;;;;CAIC;;AAED,+CAA+C;;AAE/C,wDAAwD;;AAExD,iCAAiC;;AAEjC,+CAA+C;;AAE/C,oBAAoB;;AAEpB,oEAAoE;;AAEpE,wCAAwC;;AAExC,kBAAkB;;AAElB,kBAAkB;;AAElB,0DAA0D;;AAE1D;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uCAAuC;IACvC,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,SAAS;IACT,OAAO;IACP,6CAA6C;IAC7C,qBAAqB;IACrB,wBAAwB;AAC5B;;AAEA;IACI,0BAA0B;IAC1B,6BAA6B;AACjC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,mDAAmD;IACnD,oDAAoD;IACpD,uBAAuB;IACvB,uCAAuC;;IAEvC;;;;;KAKC;IACD,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;IAClB,kDAAkD;AACtD;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,mDAAmD;IACnD,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,kDAAkD;AACtD;;AAEA;IACI;;;KAGC;IACD,oBAAoB;IACpB,aAAa,EAAE,qCAAqC;AACxD;;AAEA;;;;CAIC;;AAED;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB","sourcesContent":["/* make sure to keep these in sync with other constants,\ne.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */\n\n/* layout contants from `layout-constants.js` */\n\n/* overridden by src/lib/themes/guiHelpers.js */\n\n/*\n    Contains constants for the z-index values of elements that are part of the global stack context.\n    In other words, z-index values that are \"inside\" a component are not added here.\n    This prevents conflicts between identical z-index values in different components.\n*/\n\n/* Toolbox z-index: 40; set in scratch-blocks */\n\n/* tooltips should go over add buttons if they overlap */\n\n/* monitors go over add buttons */\n\n/* \"ask\" block text input goes above monitors */\n\n/* behind menu-bar */\n\n/* Block drag z-index: 1000; default 50 is overriden in blocks.css */\n\n/* so it is draggable into other panes */\n\n/* behind modals */\n\n/* behind modals */\n\n/* in most interfaces, the context menu is always on top */\n\n.blocks {\n    height: 100%;\n}\n\n.drag-over:after {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    opacity: 0.75;\n    background-color: var(--drop-highlight);\n    transition: all 0.25s ease;\n}\n\n.blocks :global(.injectionDiv){\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    border: 1px solid var(--ui-black-transparent);\n    border-top-width: 0px;\n    border-bottom-width: 0px;\n}\n\n[dir=\"rtl\"] .blocks :global(.injectionDiv) {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n}\n\n.blocks :global(.blocklyMainBackground) {\n    stroke: none;\n}\n\n.blocks :global(.blocklyToolboxDiv) {\n    border-right: 1px solid var(--ui-black-transparent);\n    border-bottom: 1px solid var(--ui-black-transparent);\n    box-sizing: content-box;\n    height: calc(100% - 3.25rem) !important;\n\n    /*\n        For now, the layout cannot support scrollbars in the category menu.\n        The line below works for Edge, the `::-webkit-scrollbar` line\n        below that is for webkit browsers. It isn't possible to do the\n        same for Firefox, so a different solution may be needed for them.\n    */\n    -ms-overflow-style: none;\n}\n\n[dir=\"rtl\"] .blocks :global(.blocklyToolboxDiv) {\n    border-right: none;\n    border-left: 1px solid var(--ui-black-transparent);\n}\n\n.blocks :global(.blocklyToolboxDiv::-webkit-scrollbar) {\n    display: none;\n}\n\n.blocks :global(.blocklyFlyout) {\n    border-right: 1px solid var(--ui-black-transparent);\n    box-sizing: content-box;\n}\n\n[dir=\"rtl\"] .blocks :global(.blocklyFlyout) {\n    border-right: none;\n    border-left: 1px solid var(--ui-black-transparent);\n}\n\n.blocks :global(.blocklyBlockDragSurface) {\n    /*\n        Fix an issue where the drag surface was preventing hover events for sharing blocks.\n        This does not prevent user interaction on the blocks themselves.\n    */\n    pointer-events: none;\n    z-index: 1000; /* make blocks match gui drag layer */\n}\n\n/*\n    Shrink category font to fit \"My Blocks\" for now.\n    Probably will need different solutions for language support later, so\n    make the change here instead of in scratch-blocks.\n*/\n\n.blocks :global(.scratchCategoryMenuItemLabel) {\n    font-size: 0.65rem;\n}\n\n.blocks :global(.blocklyMinimalBody) {\n    min-width: auto;\n    min-height: auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"blocks": `blocks_blocks_xkzYb`,
	"drag-over": `blocks_drag-over_giZQU`,
	"dragOver": `blocks_drag-over_giZQU`
};
export default ___CSS_LOADER_EXPORT___;
